<div class="volume">
  @for (volume of audioVolume(); track $index) {
    <div class="bar" [style.--volume]="(volume / maxVolume()) * 100 + '%'"></div>
  }
</div>
